//+1 (###) ###-####
const PHONE_FORMAT = {
  0: '+',
  1: '1',
  2: ' ',
  3: '(',
  7: ')',
  8: ' ',
  12: '-'
};
const DASH_INDEX = 12;
const LAST_SPACE_INDEX = 8;
const MAX_NUMBER_LENGTH = 17;
const PREFIX_LENGTH = 4;
const RIGHT_BRACKET_INDEX = 7;
export { PHONE_FORMAT, DASH_INDEX, LAST_SPACE_INDEX, MAX_NUMBER_LENGTH, PREFIX_LENGTH, RIGHT_BRACKET_INDEX };